import DataMap from 'assets/components/dataMap/DataMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales, Language } from 'assets/locales/Locale';
import { values } from 'lodash';
import { useDealerGroupProvider } from '../../DealerGroup.Hooks';
import ProductDocumentTranslation from './DealerGroup.ProductDocumentTranslation';
import { Fragment } from 'react';

const DealerGroupProductDocumentForm = () => {
  const { productsPayload } = useDealerGroupProvider();
  const { lang } = getLocales();

  return (
    <table className={ThemeTableSimple}>
      <DataMap
        data={productsPayload?.data ?? []}
        render={({ data: product }) =>
          !product.productDocuments.length ? null : (
            <Fragment key={product.id}>
              <thead>
                <tr>
                  <th>{product.name}</th>
                  <DataMap
                    data={values(Language)}
                    render={({ data: langIsoCode }) => <th key={langIsoCode}>{lang[langIsoCode]}</th>}
                  />
                </tr>
              </thead>
              <tbody>
                <DataMap
                  data={product.productDocuments}
                  render={({ data: productDocument }) => {
                    return (
                      <tr key={productDocument.id}>
                        <td>{productDocument.displayInfo.title}</td>
                        <DataMap
                          data={values(Language)}
                          render={({ data: languageIsoCode }) => (
                            <td key={languageIsoCode}>
                              <ProductDocumentTranslation
                                languageIsoCode={languageIsoCode}
                                productDocument={productDocument}
                              />
                            </td>
                          )}
                        />
                      </tr>
                    );
                  }}
                />
              </tbody>
            </Fragment>
          )
        }
      />
    </table>
  );
};

export default DealerGroupProductDocumentForm;
